// removed by extract-text-webpack-plugin
module.exports = {"primary":"_2ZmqL","root":"_2XPQf","bannerContent":"_26Jxx","description":"_NzJIp","icon":"_Ea4td","closeIcon":"_3Wzw2","eve":"_2QIcL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PromotionBanner/PromotionBanner.scss
// module id = 1305
// module chunks = 3